<template lang="html">
  <div class="batch-rules">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">{{t('titleBatchRules','titleBatchRules')}}</h6>
          <div class="element-box">
            <div class="element-info no-border">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <fontAwesomeIcon :icon="['fa', 'clipboard-list']" />
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">{{t('titleBatchRules','titleBatchRules')}}</h5>
                      <div class="element-inner-desc">{{t('descBatchRules','descBatchRules')}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <vcl-table v-if="isBusy" :rows="10" :columns="3"></vcl-table>
            <b-card v-if="!isBusy" no-body>
              <b-tabs v-model="tabIndex" @activate-tab="tabChanged()" pills card vertical>
                <b-tab :title="t('batchTypes', 'batchTypes')" class="">
                  <h5>{{t('titleBatchTypeRules','titleBatchTypeRules')}}</h5>
                  <div v-if="batchTypes && (Number(userLevel) > 2.50)">
                    {{t('selectBatchTypeFromTheMenu','selectBatchTypeFromTheMenu')}}
                  </div>
                  <div v-else>
                    <template v-if="Number(userLevel) > 2.50">
                      {{t('noBatchTypeFound','noBatchTypeFound')}}
                    </template>
                    <template v-else>
                      {{t('youNeedNewsnetLevelToAccessThisPage','youNeedNewsnetLevelToAccessThisPage')}}
                    </template>
                  </div>
                </b-tab>
                <template v-if="batchTypes && (Number(userLevel) > 2.50)">
                  <b-tab v-for="(batchType, key) in batchTypes" :key="key" :title="batchType.name">
                    <h5 class="pb-5">{{t('batchTypeRulesFor','batchTypeRulesFor') + ' ' + batchType.name}}</h5>
                    <form v-on:submit.prevent="updateRules">
                      <h6 class="element-header">{{t('labelReportingRules', 'labelReportingRules')}}</h6>
                      <div class="col-12 row">
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.emailForProof[batchType.id]" class="form-group">
                            <label :for="'email-proof-' + batchType.id" class="d-block text-center">{{t('labelEmailAddressForProofReports','labelEmailAddressForProofReports') }}</label>
                            <input :id="'email-proof-' + batchType.id"  :value="batchRules.emailForProof[batchType.id]" @input="batchRules.emailForProof[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelEmailAddressForProofReports','labelEmailAddressForProofReports')" type="text">
                          </div>
                          <div v-else>
                            <label :for="'email-proof-' + batchType.id" class="d-block text-center">{{t('labelEmailAddressForProofReports','labelEmailAddressForProofReports') }}</label>
                            <input v-if="batchRulesInit.emailForProof" :id="'email-proof-' + batchType.id"  :value="batchRulesInit.emailForProof[batchType.id]" @input="batchRules.emailForProof[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelEmailAddressForProofReports','labelEmailAddressForProofReports')" type="text">
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.emailForProofReminder[batchType.id]" class="form-group">
                            <label :for="'email-proof-reminder-' + batchType.id" class="d-block text-center">{{t('labelEmailAddressForProofReminder','labelEmailAddressForProofReminder') }}</label>
                            <input :id="'email-proof-reminder-' + batchType.id" :value="batchRules.emailForProofReminder[batchType.id]" @input="batchRules.emailForProofReminder[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelEmailAddressForProofReminder','labelEmailAddressForProofReminder')" type="text">
                          </div>
                          <div v-else class="form-group">
                            <label :for="'email-proof-reminder-' + batchType.id" class="d-block text-center">{{t('labelEmailAddressForProofReminder','labelEmailAddressForProofReminder') }}</label>
                            <input v-if="batchRulesInit.emailForProofReminder" :id="'email-proof-reminder-' + batchType.id" :value="batchRulesInit.emailForProofReminder[batchType.id]" @input="batchRules.emailForProofReminder[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelEmailAddressForProofReminder','labelEmailAddressForProofReminder')" type="text">
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.delayProofReminder[batchType.id]" class="form-group">
                            <label :for="'delay-proof-reminder-' + batchType.id" class="d-block text-center">{{t('labelDelayForProofReminder','labelDelayForProofReminder') }}</label>
                            <input :id="'delay-proof-reminder-' + batchType.id" :value="batchRules.delayProofReminder[batchType.id]" @input="batchRules.delayProofReminder[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelDelayForProofReminder','labelDelayForProofReminder')" type="text">
                          </div>
                          <div v-else class="form-group">
                            <label :for="'delay-proof-reminder-' + batchType.id" class="d-block text-center">{{t('labelDelayForProofReminder','labelDelayForProofReminder') }}</label>
                            <input v-if="batchRulesInit.delayProofReminder" :id="'delay-proof-reminder-' + batchType.id" :value="batchRulesInit.delayProofReminder[batchType.id]" @input="batchRules.delayProofReminder[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelDelayForProofReminder','labelDelayForProofReminder')" type="text">
                          </div>
                        </div>
                      </div>
                      <div class="col-12 row">
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.emailForReportStart[batchType.id]" class="form-group">
                            <label :for="'email-report-start-' + batchType.id" class="d-block text-center">{{t('labelEmailReportStart','labelEmailReportStart') }}</label>
                            <input :id="'email-report-start-' + batchType.id" :value="batchRules.emailForReportStart[batchType.id]" @input="batchRules.emailForReportStart[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelEmailReportStart','labelEmailReportStart')" type="text">
                          </div>
                          <div v-else class="form-group">
                            <label :for="'email-report-start-' + batchType.id" class="d-block text-center">{{t('labelEmailReportStart','labelEmailReportStart') }}</label>
                            <input v-if="batchRulesInit.emailForReportStart" :id="'email-report-start-' + batchType.id" :value="batchRulesInit.emailForReportStart[batchType.id]" @input="batchRules.emailForReportStart[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelEmailReportStart','labelEmailReportStart')" type="text">
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.emailForReportProgress[batchType.id]" class="form-group">
                            <label :for="'email-report-progress-' + batchType.id" class="d-block text-center">{{t('labelEmailReportProgress','labelEmailReportProgress') }}</label>
                            <input :id="'email-report-progress-' + batchType.id" :value="batchRules.emailForReportProgress[batchType.id]" @input="batchRules.emailForReportProgress[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelEmailReportProgress','labelEmailReportProgress')" type="text">
                          </div>
                          <div v-else class="form-group">
                            <label :for="'email-report-progress-' + batchType.id" class="d-block text-center">{{t('labelEmailReportProgress','labelEmailReportProgress') }}</label>
                            <input v-if="batchRulesInit.emailForReportProgress" :id="'email-report-progress-' + batchType.id" :value="batchRulesInit.emailForReportProgress[batchType.id]" @input="batchRules.emailForReportProgress[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelEmailReportProgress','labelEmailReportProgress')" type="text">
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.emailForReportFinal[batchType.id]" class="form-group">
                            <label :for="'email-report-final-' + batchType.id" class="d-block text-center">{{t('labelEmailReportFinal','labelEmailReportFinal') }}</label>
                            <input :id="'email-report-final-' + batchType.id" :value="batchRules.emailForReportFinal[batchType.id]" @input="batchRules.emailForReportFinal[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelEmailReportFinal','labelEmailReportFinal')" type="text">
                          </div>
                          <div v-else class="form-group">
                            <label :for="'email-report-final-' + batchType.id" class="d-block text-center">{{t('labelEmailReportFinal','labelEmailReportFinal') }}</label>
                            <input v-if="batchRulesInit.emailForReportFinal" :id="'email-report-final-' + batchType.id" :value="batchRulesInit.emailForReportFinal[batchType.id]" @input="batchRules.emailForReportFinal[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelEmailReportFinal','labelEmailReportFinal')" type="text">
                          </div>
                        </div>
                      </div>
                      <div class="col-12 row">
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div class="form-group">
                            <label :for="'report-rule-precedence-' + batchType.id" class="d-block text-center">{{t('labeReportRulePrecedence','labeReportRulePrecedence') }}</label>
                            <template v-if="batchRulesInit.reportRulePrecedence">
                              <select v-if="batchRules.reportRulePrecedence[batchType.id]" :id="'report-rule-precedence-' + batchType.id"  :value="batchRules.reportRulePrecedence[batchType.id]" @input="batchRules.reportRulePrecedence[batchType.id] = $event.target.value" class="form-control custom-select text-capitalize">
                                <option :value="null" selected>{{ t('selectOption', 'selectOption') }}</option>
                                <option v-for="(option, key) in precedenceOptions" :value="option.value" :key="key">{{ t(option.text, option.text) }}</option>
                              </select>
                              <select v-else :id="'report-rule-precedence-' + batchType.id"  :value="batchRulesInit.reportRulePrecedence[batchType.id]" @input="batchRules.reportRulePrecedence[batchType.id] = $event.target.value" class="form-control custom-select text-capitalize">
                                <option :value="null" selected>{{ t('selectOption', 'selectOption') }}</option>
                                <option v-for="(option, key) in precedenceOptions" :value="option.value" :key="key">{{ t(option.text, option.text) }}</option>
                              </select>
                            </template>
                          </div>
                        </div>
                      </div>
                      <h6 class="element-header">{{t('labelMultiblockingRules', 'labelMultiblockingRules')}}</h6>
                      <div class="col-12 row">
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.notes[batchType.id]" class="form-group">
                            <label :for="'notes-' + batchType.id" class="d-block text-center">{{t('labelNotes','labelNotes') }}</label>
                            <input :id="'notes-' + batchType.id" :value="batchRules.notes[batchType.id]" @input="batchRules.notes[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelNotes','labelNotes')" type="text">
                          </div>
                          <div v-else class="form-group">
                            <label :for="'notes-' + batchType.id" class="d-block text-center">{{t('labelNotes','labelNotes') }}</label>
                            <input v-if="batchRulesInit.notes" :id="'notes-' + batchType.id" :value="batchRulesInit.notes[batchType.id]" @input="batchRules.notes[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelNotes','labelNotes')" type="text">
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.allowMultiBlocking[batchType.id]" class="form-group">
                            <label :for="'allow-multi-blocking-' + batchType.id" class="d-block text-center">{{t('labeAllowMultiBlocking','labeAllowMultiBlocking') }}</label>
                            <select :disabled="(clientName == 'tota') || (clientName == 'brew') || (clientName == 'brewin') || (clientName == 'nnbrew')" :id="'allow-multi-blocking-' + batchType.id" :value="batchRules.allowMultiBlocking[batchType.id]" @input="batchRules.allowMultiBlocking[batchType.id] = $event.target.value" class="form-control custom-select text-capitalize">
                              <option :value="'none'">{{ t('labelNone', 'labelNone') }}</option>
                              <option v-for="(option, key) in multiBlockingOptions" :value="option.value" :key="key">{{ t(option.text, option.text) }}</option>
                            </select>
                          </div>
                          <div v-else class="form-group">
                            <label :for="'allow-multi-blocking-' + batchType.id" class="d-block text-center">{{t('labeAllowMultiBlocking','labeAllowMultiBlocking') }}</label>
                            <select v-if="batchRulesInit.allowMultiBlocking" :disabled="(clientName == 'tota') || (clientName == 'brew') || (clientName == 'brewin') || (clientName == 'nnbrew')" :id="'allow-multi-blocking-' + batchType.id" :value="batchRulesInit.allowMultiBlocking[batchType.id]" @input="batchRules.allowMultiBlocking[batchType.id] = $event.target.value" class="form-control custom-select text-capitalize">
                              <option :value="'none'">{{ t('labelNone', 'labelNone') }}</option>
                              <option v-for="(option, key) in multiBlockingOptions" :value="option.value" :key="key">{{ t(option.text, option.text) }}</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.postageClass[batchType.id]" class="form-group">
                            <label :for="'postage-class-' + batchType.id" class="d-block text-center">{{t('labePostageClass','labePostageClass') }}</label>
                            <select :id="'postage-class-' + batchType.id" :value="batchRules.postageClass[batchType.id]" @input="batchRules.postageClass[batchType.id] = $event.target.value" class="form-control custom-select text-capitalize">
                              <option v-for="(option, key) in batchRulesInit.postageClassOptions" :value="option.value" :key="key">{{ t(option.label, option.label) }}</option>
                            </select>
                          </div>
                          <div v-else class="form-group">
                            <label :for="'postage-class-' + batchType.id" class="d-block text-center">{{t('labePostageClass','labePostageClass') }}</label>
                            <select v-if="batchRulesInit.postageClassSelected" :id="'postage-class-' + batchType.id" :value="batchRulesInit.postageClassSelected[batchType.id]" @input="batchRules.postageClass[batchType.id] = $event.target.value" class="form-control custom-select text-capitalize">
                              <option v-for="(option, key) in batchRulesInit.postageClassOptions" :value="option.value" :key="key">{{ t(option.label, option.label) }}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 row">
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.barcodePosition[batchType.id]" class="form-group">
                            <label :for="'barcode-' + batchType.id" class="d-block text-center">{{t('labelBarcodePosition','labelBarcodePosition') }}</label>
                            <input :id="'barcode-' + batchType.id" :value="batchRules.barcodePosition[batchType.id]" @input="batchRules.barcodePosition[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelBarcodePosition','labelBarcodePosition')" type="text">
                          </div>
                          <div v-else class="form-group">
                            <label :for="'barcode-' + batchType.id" class="d-block text-center">{{t('labelBarcodePosition','labelBarcodePosition') }}</label>
                            <input v-if="batchRulesInit.barcodePosition" :id="'barcode-' + batchType.id" :value="batchRulesInit.barcodePosition[batchType.id]" @input="batchRules.barcodePosition[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelBarcodePosition','labelBarcodePosition')" type="text">
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.foldingType[batchType.id]" class="form-group">
                            <label :for="'folding-type-' + batchType.id" class="d-block text-center">{{t('labeFoldingType','labeFoldingType') }}</label>
                            <select :disabled="(!batchRulesInit.foldingOptions) || (!batchRulesInit.foldingOptions.length)" :id="'folding-type-' + batchType.id" :value="batchRules.foldingType[batchType.id]" @input="batchRules.foldingType[batchType.id] = $event.target.value" class="form-control custom-select text-capitalize">
                              <option v-for="(option, key) in batchRulesInit.foldingOptions" :value="option.id" :key="key">{{ t(option.name, option.name) }}</option>
                            </select>
                          </div>
                          <div v-else class="form-group">
                            <label :for="'folding-type-' + batchType.id" class="d-block text-center">{{t('labeFoldingType','labeFoldingType') }}</label>
                            <select v-if="batchRulesInit.foldingSelected" :disabled="(!batchRulesInit.foldingOptions) || (!batchRulesInit.foldingOptions.length)" :id="'folding-type-' + batchType.id" :value="batchRulesInit.foldingSelected[batchType.id]" @input="batchRules.foldingType[batchType.id] = $event.target.value" class="form-control custom-select text-capitalize">
                              <option v-for="(option, key) in batchRulesInit.foldingOptions" :value="option.id" :key="key">{{ t(option.name, option.name) }}</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.prePrintedPaper[batchType.id]" class="form-group">
                            <label :for="'preprinted-' + batchType.id" class="d-block text-center">{{t('labePreprintedPaper','labePreprintedPaper') }}</label>
                            <select :id="'preprinted-' + batchType.id" :value="batchRules.prePrintedPaper[batchType.id]" @input="batchRules.prePrintedPaper[batchType.id] = $event.target.value" class="form-control custom-select text-capitalize">
                              <option v-for="(option, key) in batchRulesInit.preprintedPaperOptions" :value="option.id" :key="key">{{ t(option.name, option.name) }}</option>
                            </select>
                          </div>
                          <div v-else class="form-group">
                            <label :for="'preprinted-' + batchType.id" class="d-block text-center">{{t('labePreprintedPaper','labePreprintedPaper') }}</label>
                            <select v-if="batchRulesInit.prePrintedPaper" :id="'preprinted-' + batchType.id" :value="batchRulesInit.prePrintedPaper[batchType.id]" @input="batchRules.prePrintedPaper[batchType.id] = $event.target.value" class="form-control custom-select text-capitalize">
                              <option v-for="(option, key) in batchRulesInit.preprintedPaperOptions" :value="option.id" :key="key">{{ t(option.name, option.name) }}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 row">
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.duplex.hasOwnProperty(batchType.id)" class="form-group">
                            <b-form-checkbox
                              :id="'checkbox-duplex-' + batchType.id"
                              :checked="Boolean(Number(batchRules.duplex[batchType.id]))"
                              @change="checkboxChange($event, 'duplex', batchType.id)"
                              name="duplex"
                              :value="true"
                              :unchecked-value="false"
                            >
                              {{t('duplex','duplex')}}
                            </b-form-checkbox>
                          </div>
                          <div v-else class="form-group">
                            <b-form-checkbox
                              v-if="batchRulesInit.duplex"
                              :id="'checkbox-duplex-' + batchType.id"
                              :checked="batchRulesInit.duplex[batchType.id]"
                              @change="checkboxChange($event, 'duplex', batchType.id)"
                              name="duplex"
                              :value="true"
                              :unchecked-value="false"
                            >
                              {{t('duplex','duplex')}}
                            </b-form-checkbox>
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.colourPrinting.hasOwnProperty(batchType.id)" class="form-group">
                            <b-form-checkbox
                              :id="'checkbox-colour-printing-' + batchType.id"
                              :checked="Boolean(Number(batchRules.colourPrinting[batchType.id]))"
                              @change="checkboxChange($event, 'colourPrinting', batchType.id)"
                              name="colourPrinting"
                            >
                              {{t('colourPrinting','colourPrinting')}}
                            </b-form-checkbox>
                          </div>
                          <div v-else class="form-group">
                            <b-form-checkbox
                              v-if="batchRulesInit.colourPrinting"
                              :id="'checkbox-colour-printing-' + batchType.id"
                              :checked="batchRulesInit.colourPrinting[batchType.id]"
                              @change="checkboxChange($event, 'colourPrinting', batchType.id)"
                              name="colourPrinting"
                            >
                              {{t('colourPrinting','colourPrinting')}}
                            </b-form-checkbox>
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.barcodeOn.hasOwnProperty(batchType.id)" class="form-group">
                            <b-form-checkbox
                              :id="'checkbox-barcode-' + batchType.id"
                              :checked="Boolean(Number(batchRules.barcodeOn[batchType.id]))"
                              @change="checkboxChange($event, 'barcodeOn', batchType.id)"
                              name="barcodeOn"
                            >
                              {{t('barcodeOn','barcodeOn')}}
                            </b-form-checkbox>
                          </div>
                          <div v-else class="form-group">
                            <b-form-checkbox
                              v-if="batchRulesInit.barcodeOn"
                              :id="'checkbox-barcode-' + batchType.id"
                              :checked="batchRulesInit.barcodeOn[batchType.id]"
                              @change="checkboxChange($event, 'barcodeOn', batchType.id)"
                              name="barcodeOn"
                            >
                              {{t('barcodeOn','barcodeOn')}}
                            </b-form-checkbox>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 row">
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.segregateSplitters.hasOwnProperty(batchType.id)" class="form-group">
                            <b-form-checkbox
                              :id="'checkbox-segregrate-splitters-' + batchType.id"
                              :checked="Boolean(Number(batchRules.segregateSplitters[batchType.id]))"
                              @change="checkboxChange($event, 'segregateSplitters', batchType.id)"
                              name="segregateSplitters"
                            >
                              {{t('segregateSplitters','segregateSplitters')}}
                            </b-form-checkbox>
                          </div>
                          <div v-else class="form-group">
                            <b-form-checkbox
                              v-if="batchRulesInit.segregateSplitters"
                              :id="'checkbox-segregrate-splitters-' + batchType.id"
                              :checked="batchRulesInit.segregateSplitters[batchType.id]"
                              @change="checkboxChange($event, 'segregateSplitters', batchType.id)"
                              name="segregateSplitters"
                            >
                              {{t('segregateSplitters','segregateSplitters')}}
                            </b-form-checkbox>
                          </div>
                        </div>
                      </div>
                      <h6 class="element-header">{{t('labelConsolidationRules', 'labelConsolidationRules')}}</h6>
                      <div class="col-12 row">
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.emailForConsolidationReports[batchType.id]" class="form-group">
                            <label :for="'email-consolidation-report-' + batchType.id" class="d-block text-center">{{t('labelEmailAddressForConsolidationReports','labelEmailAddressForConsolidationReports') }}</label>
                            <input :id="'email-consolidation-report-' + batchType.id" :value="batchRules.emailForConsolidationReports[batchType.id]" @input="batchRules.emailForConsolidationReports[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelEmailAddressForConsolidationReports','labelEmailAddressForConsolidationReports')" type="text">
                          </div>
                          <div v-else class="form-group">
                            <label :for="'email-consolidation-report-' + batchType.id" class="d-block text-center">{{t('labelEmailAddressForConsolidationReports','labelEmailAddressForConsolidationReports') }}</label>
                            <input v-if="batchRulesInit.emailForConsolidationReports" :id="'email-consolidation-report-' + batchType.id" :value="batchRulesInit.emailForConsolidationReports[batchType.id]" @input="batchRules.emailForConsolidationReports[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelEmailAddressForConsolidationReports','labelEmailAddressForConsolidationReports')" type="text">
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.minDocsConsolidationFlagging[batchType.id]" class="form-group">
                            <label :for="'min-docs-consolidation-flagging-' + batchType.id" class="d-block text-center">{{t('labelMinDocsForConsolidationFlagging','labelMinDocsForConsolidationFlagging') }}</label>
                            <input :id="'min-docs-consolidation-flagging-' + batchType.id" :value="batchRules.minDocsConsolidationFlagging[batchType.id]" @input="batchRules.minDocsConsolidationFlagging[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelMinDocsForConsolidationFlagging','labelMinDocsForConsolidationFlagging')" type="text">
                          </div>
                          <div v-else class="form-group">
                            <label :for="'min-docs-consolidation-flagging-' + batchType.id" class="d-block text-center">{{t('labelMinDocsForConsolidationFlagging','labelMinDocsForConsolidationFlagging') }}</label>
                            <input v-if="batchRulesInit.minDocsConsolidationFlagging" :id="'min-docs-consolidation-flagging-' + batchType.id" :value="batchRulesInit.minDocsConsolidationFlagging[batchType.id]" @input="batchRules.minDocsConsolidationFlagging[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelMinDocsForConsolidationFlagging','labelMinDocsForConsolidationFlagging')" type="text">
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.delayConsolidation[batchType.id]" class="form-group">
                            <label :for="'delay-consolidation-' + batchType.id" class="d-block text-center">{{t('labelDelayBeforeConsolidationEmail','labelDelayBeforeConsolidationEmail') }}</label>
                            <input :id="'delay-consolidation-' + batchType.id" :value="batchRules.delayConsolidation[batchType.id]" @input="batchRules.delayConsolidation[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelDelayBeforeConsolidationEmail','labelDelayBeforeConsolidationEmail')" type="text">
                          </div>
                          <div v-else class="form-group">
                            <label :for="'delay-consolidation-' + batchType.id" class="d-block text-center">{{t('labelDelayBeforeConsolidationEmail','labelDelayBeforeConsolidationEmail') }}</label>
                            <input v-if="batchRulesInit.delayConsolidation" :id="'delay-consolidation-' + batchType.id" :value="batchRulesInit.delayConsolidation[batchType.id]" @input="batchRules.delayConsolidation[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelDelayBeforeConsolidationEmail','labelDelayBeforeConsolidationEmail')" type="text">
                          </div>
                        </div>
                      </div>
                      <div class="col-12 row">
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.variationAllowedForDelivery[batchType.id]" class="form-group">
                            <label :for="'variation-allowed-delivery' + batchType.id" class="d-block text-center">{{t('labelVariationAllowedForDelivery','labelVariationAllowedForDelivery') }}</label>
                            <input :id="'variation-allowed-delivery-' + batchType.id" :value="batchRules.variationAllowedForDelivery[batchType.id]" @input="batchRules.variationAllowedForDelivery[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelVariationAllowedForDelivery','labelVariationAllowedForDelivery')" type="text">
                          </div>
                          <div v-else class="form-group">
                            <label :for="'variation-allowed-delivery' + batchType.id" class="d-block text-center">{{t('labelVariationAllowedForDelivery','labelVariationAllowedForDelivery') }}</label>
                            <input v-if="batchRulesInit.variationAllowedForDelivery" :id="'variation-allowed-delivery-' + batchType.id" :value="batchRulesInit.variationAllowedForDelivery[batchType.id]" @input="batchRules.variationAllowedForDelivery[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelVariationAllowedForDelivery','labelVariationAllowedForDelivery')" type="text">
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.minimumElectronicDeliveryRequired[batchType.id]" class="form-group">
                            <label :for="'min-electronic-delivery-' + batchType.id" class="d-block text-center">{{t('labelMinimumElectronicDeliveryRequired','labelMinimumElectronicDeliveryRequired') }}</label>
                            <input :id="'min-electronic-delivery-' + batchType.id" :value="batchRules.minimumElectronicDeliveryRequired[batchType.id]" @input="batchRules.minimumElectronicDeliveryRequired[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelMinimumElectronicDeliveryRequired','labelMinimumElectronicDeliveryRequired')" type="text">
                          </div>
                          <div v-else class="form-group">
                            <label :for="'min-electronic-delivery-' + batchType.id" class="d-block text-center">{{t('labelMinimumElectronicDeliveryRequired','labelMinimumElectronicDeliveryRequired') }}</label>
                            <input v-if="batchRulesInit.minimumElectronicDeliveryRequired" :id="'min-electronic-delivery-' + batchType.id" :value="batchRulesInit.minimumElectronicDeliveryRequired[batchType.id]" @input="batchRules.minimumElectronicDeliveryRequired[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelMinimumElectronicDeliveryRequired','labelMinimumElectronicDeliveryRequired')" type="text">
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.maximumOnlineDeliveryAllowed[batchType.id]" class="form-group">
                            <label :for="'max-online-delivery-' + batchType.id" class="d-block text-center">{{t('labelMaximumOnlineDeliveryAllowed','labelMaximumOnlineDeliveryAllowed') }}</label>
                            <input :id="'max-online-delivery-' + batchType.id" :value="batchRules.maximumOnlineDeliveryAllowed[batchType.id]" @input="batchRules.maximumOnlineDeliveryAllowed[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelMaximumOnlineDeliveryAllowed','labelMaximumOnlineDeliveryAllowed')" type="text">
                          </div>
                          <div v-else class="form-group">
                            <label :for="'max-online-delivery-' + batchType.id" class="d-block text-center">{{t('labelMaximumOnlineDeliveryAllowed','labelMaximumOnlineDeliveryAllowed') }}</label>
                            <input v-if="batchRulesInit.maximumOnlineDeliveryAllowed" :id="'max-online-delivery-' + batchType.id" :value="batchRulesInit.maximumOnlineDeliveryAllowed[batchType.id]" @input="batchRules.maximumOnlineDeliveryAllowed[batchType.id] = $event.target.value" class="form-control text-center" :placeholder="t('labelMaximumOnlineDeliveryAllowed','labelMaximumOnlineDeliveryAllowed')" type="text">
                          </div>
                        </div>
                      </div>
                      <h6 class="element-header">{{t('labelCoversheetSettings', 'labelCoversheetSettings')}}</h6>
                      <div class="col-12 row">
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.emailCoversheet.hasOwnProperty(batchType.id)" class="form-group">
                            <b-form-checkbox
                              :id="'checkbox-coversheet-email-' + batchType.id"
                              :checked="Boolean(Number(batchRules.emailCoversheet[batchType.id]))"
                              @change="checkboxChange($event, 'emailCoversheet', batchType.id)"
                              name="coversheetEmail"
                            >
                              {{t('emailCoversheet','emailCoversheet')}}
                            </b-form-checkbox>
                          </div>
                          <div v-else class="form-group">
                            <b-form-checkbox
                              v-if="batchRulesInit.emailCoversheet"
                              :id="'checkbox-coversheet-email-' + batchType.id"
                              :checked="batchRulesInit.emailCoversheet[batchType.id]"
                              @change="checkboxChange($event, 'emailCoversheet', batchType.id)"
                              name="coversheetEmail"
                            >
                              {{t('emailCoversheet','emailCoversheet')}}
                            </b-form-checkbox>
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.postCoversheet.hasOwnProperty(batchType.id)" class="form-group">
                            <b-form-checkbox
                              :id="'checkbox-coversheet-post-' + batchType.id"
                              :checked="Boolean(Number(batchRules.postCoversheet[batchType.id]))"
                              @change="checkboxChange($event, 'postCoversheet', batchType.id)"
                              name="coversheetPost"
                            >
                              {{t('postCoversheet','postCoversheet')}}
                            </b-form-checkbox>
                          </div>
                          <div v-else class="form-group">
                            <b-form-checkbox
                              v-if="batchRulesInit.postCoversheet"
                              :id="'checkbox-coversheet-post-' + batchType.id"
                              :checked="batchRulesInit.postCoversheet[batchType.id]"
                              @change="checkboxChange($event, 'postCoversheet', batchType.id)"
                              name="coversheetPost"
                            >
                              {{t('postCoversheet','postCoversheet')}}
                            </b-form-checkbox>
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                          <div v-if="batchRules.faxCoversheet.hasOwnProperty(batchType.id)" class="form-group">
                            <b-form-checkbox
                              :id="'checkbox-coversheet-fax-' + batchType.id"
                              :checked="Boolean(Number(batchRules.faxCoversheet[batchType.id]))"
                              @change="checkboxChange($event, 'faxCoversheet', batchType.id)"
                              name="coversheetFax"
                            >
                              {{t('faxCoversheet','faxCoversheet')}}
                            </b-form-checkbox>
                          </div>
                          <div v-else class="form-group">
                            <b-form-checkbox
                              v-if="batchRulesInit.faxCoversheet"
                              :id="'checkbox-coversheet-fax-' + batchType.id"
                              :checked="batchRulesInit.faxCoversheet[batchType.id]"
                              @change="checkboxChange($event, 'faxCoversheet', batchType.id)"
                              name="coversheetFax"
                            >
                              {{t('faxCoversheet','faxCoversheet')}}
                            </b-form-checkbox>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 row pt-5 border-top"></div>
                      <ResponseInfo class="mb-3" v-if="getResponseInfo.responseName == 'batchRules'" />
                      <template v-if="getResponseInfo.key == 'invalidEmailAddressGiven'">
                        <div class="col-12 mb-3">
                          <b-alert variant="danger" show fade>
                            <p>
                              <span>{{t('field', 'field')}}: </span>
                              <span>{{t(getResponseInfo.field, getResponseInfo.field)}}</span>
                            </p>
                          </b-alert>
                        </div>
                      </template>
                      <div class="col-12 row align-items-baseline justify-content-between">
                        <p class="">{{ t('descMultipleEmailsBySemicolonInstruction','descMultipleEmailsBySemicolonInstruction') }}</p>
                        <button class="btn btn-primary float-right ml-2" type="submit" >{{ t('buttonTextUpdate','buttonTextUpdate') }}</button>
                      </div>
                    </form>
                  </b-tab>
                </template>
              </b-tabs>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { clientShortName } from '@/helpers/clientShortName.js'
import ResponseInfo from '@/components/ResponseInfo.vue'
import { VclTable } from 'vue-content-loading'

export default {
  name: 'batch_rules',
  data() {
    return {
      tabIndex: 0,
      isBusy: false,
      //mobile: window.innerWidth <= 700,
      precedenceOptions: [
        { value: 'send_to_netsend', text: 'optionSendToNetsend' },
        { value: 'ignore_principles', text: 'optionIgnorePrinciples' },
        { value: 'ignore_batch_types', text: 'optionIgnoreBatchTypes' },
        { value: 'principles_first', text: 'optionPrinciplesFirst' },
        { value: 'batch_types_first', text: 'optionBatchTypesFirst' },
        { value: 'both', text: 'optionBoth' }
      ],
      multiBlockingOptions: [
        { value: 'per_client', text: 'optionPerClient' },
        { value: 'across_clients', text: 'optionAcrossClients' }
      ],
      batchRules: {
        //Reporting Rules
        emailForProof: {},
        emailForProofReminder: {},
        delayProofReminder: {},
        emailForReportStart: {},
        emailForReportProgress: {},
        emailForReportFinal: {},
        reportRulePrecedence: {},
        //Multiblocking rules
        notes: {},
        allowMultiBlocking: {},
        postageClass: {},
        barcodePosition: {},
        foldingType: {},
        prePrintedPaper: {},
        duplex: {},
        colourPrinting: {},
        barcodeOn: {},
        segregateSplitters: {},
        //Consolidation rules
        emailForConsolidationReports: {},
        minDocsConsolidationFlagging: {},
        delayConsolidation: {},
        variationAllowedForDelivery: {},
        minimumElectronicDeliveryRequired: {},
        maximumOnlineDeliveryAllowed: {},
        //Coversheet settings
        emailCoversheet: {},
        postCoversheet: {},
        faxCoversheet: {}
      }
    }
  },
  methods: {
    updateRules() {
      this.isBusy = true
      this.$store.dispatch('batchRulesStore/updateBatchRules', {
        data: this.batchRules
      })
      .then(() => {
        let response = this.getResponseInfo
        if(response.status == 'success') {
          Object.keys(this.batchRules).forEach((key) => {this.batchRules[key] = {}})

          this.$store.dispatch('batchRulesStore/getBatchRulesToDisplay').then(() => {})
        }
        this.isBusy = false
      })
    },
    checkboxChange(event, dataType, batchType) {
      let checked = (event) ? 1 : 0
      this.batchRules[dataType][batchType] = checked
    },
    tabChanged() {
      this.$store.dispatch('alertClearResponse')
      Object.keys(this.batchRules).forEach((key) => (this.batchRules[key] = {}))
    }
  },
  computed:{
      ...mapGetters(['getResponseInfo']),
      batchTypes() {
        return this.$store.getters['batchRulesStore/getBatchTypes']
      },
      userLevel() {
        return this.$store.getters.getUserLevel
      },
      clientName() {
        let clientName = clientShortName()
        return clientName
      },
      batchRulesInit() {
        return this.$store.getters['batchRulesStore/getBatchRulesForDisplay']
      }
  },
  created() {
    this.$store.dispatch('batchRulesStore/getBatchTypes').then(() => {})

    this.$store.dispatch('batchRulesStore/getBatchRulesToDisplay').then(() => {})
  },
  components: {
    ResponseInfo,
    VclTable
  }
}
</script>

<style lang="css" scoped>
.no-border {
  border: none;
}
</style>
